<div [class]="direction">
    <mpro-notification
        *ngFor="let notification of notifications; index as i;"
        [title]="notification.title"
        [text]="notification.text"
        [dismiss]="notification.dismiss"
        [button]="notification.button"
        [time]="notification.time"
        [color]="notification.color"
        [dark]="notification.dark"
        [maxWidth]="notification.maxWidth"
        (dismissEvent)="remove(i)"
        >
    </mpro-notification>
</div>